const DEFAULT_REFER_TERMS_URL = 'https://www.footprintseducation.in/privacy-policy';

const DEFAULT_REFER_PAGE_SUBTITLE =
    'Invite a friend and you both get rewarded when your referred friend successfully enrolls their child.';

const DEFAULT_REFER_EARN_SUBTITLE =
    'Earn a {{referrerCredit}} Referral Credit on the upcoming monthly invoice.';

const DEFAULT_REFER_DISCOUNT_SUBTITLE =
    'Your referred friend receives a {{refereeDiscount}} discount on admission fee.';

const DEFAULT_REFER_SHARE_MESSAGE = `Looking for a great preschool experience? Join the Footprints Preschool family!

Use my referral link to admission and get an instant {{rewardAmount}} discount on your monthly fees.

🎁 Your Reward: {{rewardAmount}} Off
🎫 Referral Code: {{code}}
📲 Get Started: https://www.footprintseducation.in/`;

const textOrDefault = (value, fallback) => {
    if (typeof value !== 'string') return fallback;
    const trimmed = value.trim();
    return trimmed || fallback;
};

const fillTemplate = (template, values) =>
    String(template).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) =>
        values[key] == null ? '' : String(values[key])
    );

const displayOrDash = (value) => {
    const raw = value != null ? String(value).trim() : '';
    return raw || '—';
};

const formatRewardAmount = (value) => {
    const raw = value != null ? String(value).trim() : '';
    if (!raw) return '₹0';
    return raw.startsWith('₹') ? raw : `₹${raw}`;
};

export const isReferFriendsVisible = (constants) => {
    const value = constants?.showReferFriendsInMore;
    if (value === true) return true;
    if (typeof value === 'string' && value.toLowerCase() === 'true') return true;
    return false;
};

export const getReferralCopy = (constants = {}, { referralCode, referrerCredit, refereeDiscount } = {}) => {
    const code = referralCode ? String(referralCode).trim() : '';
    const referrerCreditLabel = displayOrDash(referrerCredit);
    const refereeDiscountLabel = displayOrDash(refereeDiscount);

    return {
        termsUrl: textOrDefault(constants.referTermsUrl, DEFAULT_REFER_TERMS_URL),
        pageSubtitle: textOrDefault(constants.referPageSubtitle, DEFAULT_REFER_PAGE_SUBTITLE),
        earnSubtitle: fillTemplate(
            textOrDefault(constants.referEarnSubtitle, DEFAULT_REFER_EARN_SUBTITLE),
            { referrerCredit: referrerCreditLabel }
        ),
        discountSubtitle: fillTemplate(
            textOrDefault(constants.referDiscountSubtitle, DEFAULT_REFER_DISCOUNT_SUBTITLE),
            { refereeDiscount: refereeDiscountLabel }
        ),
        shareMessage: fillTemplate(
            textOrDefault(constants.referShareMessage, DEFAULT_REFER_SHARE_MESSAGE),
            {
                rewardAmount: formatRewardAmount(refereeDiscount),
                code: code || 'your referral code',
            }
        ),
    };
};
